import { createPlatformSiteAri } from '@townsquare/collab-context/create-site-ari';
import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceStoreContext, RouterContext, RouterDataContext } from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import DirectoryViewQuery, {
	type AggDirectoryViewQuery as DirectoryViewQueryType,
} from '../__generated__/AggDirectoryViewQuery.graphql';

export const getTeamDirectoryTableResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<DirectoryViewQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const siteId = context.collabContext?.rovoWorkspace || context.workspace?.cloudId || '';
	const scopeId = createPlatformSiteAri(siteId) ?? '';
	const q = routerContext.query.tql || '';

	return {
		environment: getAggRelayEnvironment(),
		query: DirectoryViewQuery,
		variables: {
			scopeId,
			q,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const teamDirectoryTableResource = createRelayResource<DirectoryViewQueryType>({
	getQuery: getTeamDirectoryTableResourceQuery,
});
